import * as t from './reducers';
import { Action, ActionReducerMap, combineReducers, compose } from '@ngrx/store';

export const featureKey = 'commentingFeature';

export interface CommentingState {
  threadState?: t.ThreadState;
  commentState?: t.CommentState;
  userState?: t.UserState;
}

export const reducers: ActionReducerMap<CommentingState> = {
  threadState: t.threadReducer,
  commentState: t.commentReducer,
  userState: t.userReducer,
};

export function store(state: unknown, action: Action): CommentingState {
  const store = compose(combineReducers)(reducers);
  return store(state, action);
}
